import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import { useUserFav } from '../../context/User/UserFavContext';
import Pagination from "../../utilities/Pagination";
import BookSampleImg from "../../assets/defaults/BookSample-1.png";
import { toast, ToastContainer } from 'react-toastify';
import { deleteBooksFav } from '../../hooks/apiAxios';
import { useTranslation } from 'react-i18next';
import SuccessErrorMsg from '../../utilities/SuccessErrorMsg';
import { Link } from 'react-router-dom';
import { formatTitleForUrl } from '../../lib/formatTitleForUrl';

export default function MyFavorits() {
    const { loading, setLoading, favBooks, currentPage, setCurrentPage } = useUserFav();
    const totalPages = favBooks?.data?.paginationInfo.totalPagesCount;
    const totalCount = favBooks?.data?.paginationInfo.totalCount;
    const { t, i18n } = useTranslation();
    console.log(totalCount);

    async function HandleFavRemove(id) {
        setLoading(true);

        try {
            const response = await deleteBooksFav(id);

            if (response.data.isSuccess) {
                // setDataUpdate(true);
                toast.success(t("SuccessMessage"))
                setTimeout(() => {
                    window.location.reload();
                }, 3000);

            } else {
                toast.error(t("errorTryAgain"));
            }
        } catch (error) {
            console.error("Error during form submission: ", error);
            toast.warn(t("errorGetSupport"));


        } finally {
            setLoading(false);

        }
    }

    const FavBooksItems = ({ title, img, imgAlt, id }) => (
        <div key={id} className="book-container col-12 col-sm-6 col-lg-4 my-3 text-decoration-none text-black">
            <button className="btn-masar text-secondary p-1 rounded position-absolute top-0 start-0 ms-3">
                <FontAwesomeIcon icon={faHeart}
                    className="books-Fav-Icon fs-5 c-darkOrange pt-1"
                    onClick={() => HandleFavRemove(id)}
                />
            </button>
            <Link className="text-decoration-none text-black w-100 d-block"
                to={`/${i18n.language}/masarLibrary/${id}/${formatTitleForUrl(title)}`}>
                <img
                    crossOrigin="anonymous"
                    src={img ? img : BookSampleImg}
                    alt={imgAlt}
                    className="rounded-2" />
                <div className="book-title p-1 rounded">
                    <p>{title}</p>
                </div>
            </Link>
        </div>

    );

    if (!favBooks || loading) {
        return <div className="loader" role="status" aria-live="polite" aria-label="Loading"></div>;
    }

    return (<>
        <div className="container my-3 rounded bg-light-gray position-relative p-3 pb-5">
            {totalCount === 0 ? (i18n.language === "ar" ? <p className="text-center mt-2">لا يوجد كتب في المفضلة</p>
                : <p className="text-center mt-2">There are no books in your favorites</p>) :
                <div className="d-flex flex-wrap justify-content-center justify-content-md-start">
                    {favBooks?.data?.result.map((data) => (
                        <FavBooksItems
                            key={data.bookId}
                            id={data.bookId}
                            title={data.book.title}
                            img={data.book.thumbnail}
                            imgAlt={`book_${data.bookId}`} />
                    ))}
                </div>
            }
            {totalPages > 1 &&
                <Pagination
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    totalPages={totalPages} />
            }
        </div>
        <SuccessErrorMsg
            ToastContainer={ToastContainer} />
    </>
    )
}
// to Add 
// Ordar Approved or Rejected from user